import React from "react";

import styles from "./ProfessionsInput.module.scss";

type IconsWrapperType = {
  hasError?: boolean;
  isValid?: boolean;
  isOther: boolean;
};

const IconsWrapper: React.FC<IconsWrapperType> = ({
  hasError,
  isValid,
  isOther,
}) => (
  <div className={styles.iconsWrapper}>
    {hasError && (
      <img
        src={`/icons/drip-form-invalid-icon.svg`}
        alt="icon"
        className={styles.icon}
      />
    )}
    {isValid && !isOther && (
      <img
        src={`/icons/drip-form-valid-icon.svg`}
        alt="icon"
        className={styles.icon}
      />
    )}
    <img
      src={`/icons/drip-form-chevron-down.svg`}
      alt="icon"
      className={styles.chevron}
    />
  </div>
);

export default IconsWrapper;
